import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  min-height: 200px;
  height: 100%;
  width: fit-content;
  justify-content: flex-end;
  padding: 2rem;
`;

export const StyledButton = styled.button`
  border: none !important;
`;
